var REACT_ELEMENT_TYPE;function _jsx(type, props, key, children) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var defaultProps = type && type.defaultProps,childrenLength = arguments.length - 3;if (props || 0 === childrenLength || (props = { children: void 0 }), 1 === childrenLength) props.children = children;else if (childrenLength > 1) {for (var childArray = new Array(childrenLength), i = 0; i < childrenLength; i++) childArray[i] = arguments[i + 3];props.children = childArray;}if (props && defaultProps) for (var propName in defaultProps) void 0 === props[propName] && (props[propName] = defaultProps[propName]);else props || (props = defaultProps || {});return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: void 0 === key ? null : "" + key, ref: null, props: props, _owner: null };}import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Icon } from "../../UI";
import { Translate } from "../../I18N";

export class PrioritySortingLabel extends Component {
  render() {
    return /*#__PURE__*/(
      _jsx("label", { className: "property-label", htmlFor: this.props.htmlFor }, void 0, /*#__PURE__*/
      _jsx(Translate, {}, void 0, "Priority sorting"), /*#__PURE__*/
      _jsx("span", { className: "property-help" }, void 0, /*#__PURE__*/
      _jsx(Icon, { icon: "question-circle" }), /*#__PURE__*/
      _jsx("div", { className: "property-description" }, void 0, /*#__PURE__*/
      _jsx(Translate, { translationKey: "Priority sorting description" }, void 0, "Properties marked as priority sorting will be used as default sorting criteria. If more than one property is marked as priority sorting the system will try to pick-up the best fit. When listing mixed template types, the system will pick-up the best combined priority sorting.")))));









  }
}





export default connect()(PrioritySortingLabel);